import { render } from "./MovAlmacenList.vue?vue&type=template&id=aeb4dc0a&scoped=true"
import script from "./MovAlmacenList.vue?vue&type=script&lang=js"
export * from "./MovAlmacenList.vue?vue&type=script&lang=js"

import "./MovAlmacenList.vue?vue&type=style&index=0&id=aeb4dc0a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeb4dc0a"]])

export default __exports__